import { render, staticRenderFns } from "./GeneralRoom.vue?vue&type=template&id=44b07cb4&scoped=true&"
import script from "./GeneralRoom.vue?vue&type=script&lang=js&"
export * from "./GeneralRoom.vue?vue&type=script&lang=js&"
import style0 from "./GeneralRoom.vue?vue&type=style&index=0&id=44b07cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b07cb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAvatar,VIcon,VListItem,VListItemContent,VListItemTitle})
